const ALL_BOARDS = "ALL_BOARDS";
const BOARD_LOADING = "BOARD_LOADING";
const LOGIN_DETAILS = "LOGIN_DETAILS";
const CREATE_SINGLE_BOARD = "CREATE_SINGLE_BOARD";
const ADDING_SINGLE_BOARD = "ADDING_SINGLE_BOARD";
const DELETE_BOARD = "DELETE_BOARD";
const ADDING_ATTRIBUTE = "ADDING_ATTRIBUTE";
const CREATE_ATTRIBUTE = "CREATE_ATTRIBUTE";
const FETCHING_ALL_COLUMNS = "FETCHING_ALL_COLUMNS";
const FETCH_DONE_FOR_COLUMNS = "FETCH_DONE_FOR_COLUMNS";
const BOARD_RENAMING = "BOARD_RENAMING";
const BOARD_RENAMED = "BOARD_RENAMED";
const COLUMN_ORDERING = "COLUMN_ORDERING";
const SEQUENCE_DONE = "SEQUENCE_DONE";
const RENAMING_ATTRIBUTE = "RENAMING_ATTRIBUTE";
const ATTRIBUTE_RENAME_DONE = "ATTRIBUTE_RENAME_DONE";
const DATA_NOT_FOUND = "DATA_NOT_FOUND";
const LINK_STATUS_CHECK = "LINK_STATUS_CHECK";
const HIDE_COLUMN = "HIDE_COLUMN";
const BOARD_ERROR = "BOARD_ERROR";
const FETCHING_ATTRIBUTE_LISTNG = "FETCHING_ATTRIBUTE_LISTNG";
const FETCHING_ATTRIBUTE_LISTING_DONE = "FETCHING_ATTRIBUTE_LISTING_DONE";
const SHOW_ATTRIBUTE = "SHOW_ATTRIBUTE";
const DEACTIVATE_BOARD = "DEACTIVATE_BOARD";
const SHOW_COLUMNS = "SHOW_COLUMNS";
const ACTIVATE_BOARD = "ACTIVATE_BOARD";
const BOARD_ATTRIBUTE_LISTING = "BOARD_ATTRIBUTE_LISTING";
const LOADING_FORM_ATTRIBUTE = "LOADING_FORM_ATTRIBUTE";
const REDIRECT_FALSE = "REDIRECT_FALSE";
const COLUMN_RESIZE = "COLUMN_RESIZE";
const RENAME_BOARD_ERROR = "RENAME_BOARD_ERROR";
const BULK_UPDATE = "BULK_UPDATE";
const CREATE_STATUS = "CREATE_STATUS";
const UPDATE_SINGLE_ROW = "UPDATE_SINGLE_ROW";
const ALL_STATUS_LIST = "ALL_STATUS_LIST";
const UPDATE_STATUS = "UPDATE_STATUS";
const STATUS_LOADING = "STATUS_LOADING";
const STATUS_GET_ALL_CATEGORY = "STATUS_GET_ALL_CATEGORY";
const STATUS_CREATE_NEW_CATEGORY = "STATUS_CREATE_NEW_CATEGORY";
const CREATE_WORKFLOW_STATUS = "CREATE_WORKFLOW_STATUS";
const GET_ALL_WORKFLOW_LIST = "GET_ALL_WORKFLOW_LIST";
const UPDATE_WORKFLOW_SINGLE = "UPDATE_WORKFLOW_SINGLE";
const CREATE_SINGLE_WORKFLOW_ERROR = "CREATE_SINGLE_WORKFLOW_ERROR";
const DELETE_SINGLE_CATEGORY_WORKFLOW = "DELETE_SINGLE_CATEGORY_WORKFLOW";
const WORKFLOW_CLOSE_MODAL = "WORKFLOW_CLOSE_MODAL";
const BOARD_MESSAGE_DEACTIVATE = "BOARD_MESSAGE_DEACTIVATE";
const STATUS_WORKFLOW_USER = "STATUS_WORKFLOW_USER";
const LINK_STATUS_CHECK_CATEGORY = "LINK_STATUS_CHECK_CATEGORY";
const NULL_WORKFLOW_LIST = "NULL_WORKFLOW_LIST";
const BOARD_ATTRIBUTE_TATTLE_DETAILS = "BOARD_ATTRIBUTE_TATTLE_DETAILS";
const GET_BOARD_STATUS_DETAILS = "GET_BOARD_STATUS_DETAILS";
const GET_ALL_WORKFLOW_USER = "GET_ALL_WORKFLOW_USER";
const GET_ALL_BOARD_HISTORY = "GET_ALL_BOARD_HISTORY";
const ADD_NOTE_BOARD = "ADD_NOTE_BOARD";
const BOARD_NOTE_LIST = "BOARD_NOTE_LIST";
const BOARD_FALSE_DEFAULT = "BOARD_FALSE_DEFAULT";
const UPDATE_SINGLE_BOARD_FALSE = "UPDATE_SINGLE_BOARD_FALSE";
const BULK_UPDATE_DONE = "BULK_UPDATE_DONE";
const KEEP_STORE_BOARD_DETAILS = "KEEP_STORE_BOARD_DETAILS";
const FETCH_DONE_FOR_ROWS = "FETCH_DONE_FOR_ROWS";
const BULK_UPDATE_PROCESS = "BULK_UPDATE_PROCESS";
const POPUP_STOP_DETAILS = "POPUP_STOP_DETAILS";
const ATTRIBUTE_MESSAGE_DEACTIVATE = "ATTRIBUTE_MESSAGE_DEACTIVATE";
const DEACTIVATE_STATUSWORKFLOW_MESSAGE = "DEACTIVATE_STATUSWORKFLOW_MESSAGE";
const SHOW_STATUS_CHANGE = "SHOW_STATUS_CHANGE";
const HIDE_STATUS_CHANGE = "HIDE_STATUS_CHANGE";
const ATTRIBUTE_POPUP_DEACTIVE = "ATTRIBUTE_POPUP_DEACTIVE";
const SET_NEW_STATUS_WORKFLOW = "SET_NEW_STATUS_WORKFLOW";
const REMOVE_ATTACHMENT = "REMOVE_ATTACHMENT";
const BOARD_ATTRIBUTE_TATTLE_DETAILS_NULL =
  "BOARD_ATTRIBUTE_TATTLE_DETAILS_NULL";
const ADDING_MONITOR = "ADDING_MONITOR";
const REMOVE_MONITOR = "REMOVE_MONITOR";
const MONITOR_ADDING = "MONITOR_ADDING";
const ENABLE_MONITORING = "ENABLE_MONITORING";
const NOTE_ADDING = "NOTE_ADDING";
const NOTE_ADDED = "NOTE_ADDED";
const BOARD_CREATING = "BOARD_CREATING";
const BOARD_CREATED = "BOARD_CREATED";
const CLEARING_ALL_COLUMNS = "CLEARING_ALL_COLUMNS";
const UPDATE_ROW_STATUS = "UPDATE_ROW_STATUS";
const IMAGE_UPLOAD_START = "IMAGE_UPLOAD_START";
const IMAGE_UPLOAD_PROGRESS = "IMAGE_UPLOAD_PROGRESS";
const IMAGE_UPLOAD_PROGRESS_COMPLETE = "IMAGE_UPLOAD_PROGRESS_COMPLETE";
const IMAGE_UPLOAD_ERROR = "IMAGE_UPLOAD_ERROR";
const BOARD_ATTRIBUTE_TATTLE_DETAILS_AFTER_UPLOAD =
  "BOARD_ATTRIBUTE_TATTLE_DETAILS_AFTER_UPLOAD";
const ASSIGN_TO_UPDATE = "ASSIGN_TO_UPDATE";
const ADD_IMAGE_TO_NOTE = "ADD_IMAGE_TO_NOTE";
const CLEAR_BOARD_REDUX = "CLEAR_BOARD_REDUX";
const IMAGE_UPLOAD_DONE = "IMAGE_UPLOAD_DONE";
const CLEAR_ALL_IMAGE = "CLEAR_ALL_IMAGE";
const IMAGE_UPLOAD_DONE_EDIT = "IMAGE_UPLOAD_DONE_EDIT";
const IMAGE_UPLOAD_PROGRESS_COMPLETE_ADD_LISTING =
  "IMAGE_UPLOAD_PROGRESS_COMPLETE_ADD_LISTING";
const IMAGE_UPLOAD_PROGRESS_ADD_LISTING = "IMAGE_UPLOAD_PROGRESS_ADD_LISTING";
const IMAGE_UPLOAD_ERROR_ADD_LISTING = "IMAGE_UPLOAD_ERROR_ADD_LISTING";
const IMAGE_UPLOAD_DONE_ADD_LISTING = "IMAGE_UPLOAD_DONE_ADD_LISTING";
const REPLY_TO_CUSTOMER = "REPLY_TO_CUSTOMER";
const IMAGE_UPLOAD_DONE_ADD_LISTING_CHILD_BOARD =
  "IMAGE_UPLOAD_DONE_ADD_LISTING_CHILD_BOARD";
const GET_CHILD_BOARD = "GET_CHILD_BOARD";
const GET_BOARD_FILTER_ACTION = "GET_BOARD_FILTER_ACTION";
const CREATE_CUSTOM_FILTER = "CREATE_CUSTOM_FILTER";
const DELETE_FILTER = "DELETE_FILTER";
const DELETE_FILTER_ERROR = "DELETE_FILTER_ERROR";
const EDIT_FILTER_HANDLER = "EDIT_FILTER_HANDLER";
const CREATE_CUSTOM_FILTER_ERROR = "CREATE_CUSTOM_FILTER_ERROR";
const TOGGLE_MENU = "TOGGLE_MENU";
const ADD_REASON_ROW_UPDATE = "ADD_REASON_ROW_UPDATE";
const CHILD_BOARD_IMAGE_REMOVE = "CHILD_BOARD_IMAGE_REMOVE";
const RESET_BOARDS = "RESET_BOARDS";
const ADD_TODO_HANDLER = "ADD_TODO_HANDLER";
const CLEAR_NOTE = "CLEAR_NOTE";
const IS_RESET_FILTER = "IS_RESET_FILTER";
const RELATE_VICE_VERSA = "RELATE_VICE_VERSA";
const USER_API_CALL = "USER_API_CALL";

export {
  USER_API_CALL,
  ALL_BOARDS,
  BOARD_LOADING,
  LOGIN_DETAILS,
  CREATE_SINGLE_BOARD,
  IS_RESET_FILTER,
  ADDING_SINGLE_BOARD,
  DELETE_BOARD,
  ADDING_ATTRIBUTE,
  CREATE_ATTRIBUTE,
  FETCH_DONE_FOR_COLUMNS,
  FETCHING_ALL_COLUMNS,
  DATA_NOT_FOUND,
  BOARD_RENAMING,
  REDIRECT_FALSE,
  BOARD_RENAMED,
  COLUMN_ORDERING,
  SEQUENCE_DONE,
  RENAMING_ATTRIBUTE,
  ATTRIBUTE_RENAME_DONE,
  LINK_STATUS_CHECK,
  HIDE_COLUMN,
  BOARD_ERROR,
  FETCHING_ATTRIBUTE_LISTNG,
  FETCHING_ATTRIBUTE_LISTING_DONE,
  SHOW_ATTRIBUTE,
  DEACTIVATE_BOARD,
  SHOW_COLUMNS,
  ACTIVATE_BOARD,
  BOARD_ATTRIBUTE_LISTING,
  LOADING_FORM_ATTRIBUTE,
  COLUMN_RESIZE,
  RENAME_BOARD_ERROR,
  BULK_UPDATE,
  CREATE_STATUS,
  UPDATE_SINGLE_ROW,
  ALL_STATUS_LIST,
  UPDATE_STATUS,
  STATUS_LOADING,
  STATUS_GET_ALL_CATEGORY,
  STATUS_CREATE_NEW_CATEGORY,
  CREATE_WORKFLOW_STATUS,
  GET_ALL_WORKFLOW_LIST,
  UPDATE_WORKFLOW_SINGLE,
  CREATE_SINGLE_WORKFLOW_ERROR,
  DELETE_SINGLE_CATEGORY_WORKFLOW,
  WORKFLOW_CLOSE_MODAL,
  BOARD_MESSAGE_DEACTIVATE,
  STATUS_WORKFLOW_USER,
  LINK_STATUS_CHECK_CATEGORY,
  NULL_WORKFLOW_LIST,
  BOARD_ATTRIBUTE_TATTLE_DETAILS,
  GET_BOARD_STATUS_DETAILS,
  GET_ALL_WORKFLOW_USER,
  GET_ALL_BOARD_HISTORY,
  ADD_NOTE_BOARD,
  BOARD_NOTE_LIST,
  BOARD_FALSE_DEFAULT,
  UPDATE_SINGLE_BOARD_FALSE,
  BULK_UPDATE_DONE,
  KEEP_STORE_BOARD_DETAILS,
  FETCH_DONE_FOR_ROWS,
  BULK_UPDATE_PROCESS,
  POPUP_STOP_DETAILS,
  ATTRIBUTE_MESSAGE_DEACTIVATE,
  DEACTIVATE_STATUSWORKFLOW_MESSAGE,
  SHOW_STATUS_CHANGE,
  HIDE_STATUS_CHANGE,
  ATTRIBUTE_POPUP_DEACTIVE,
  SET_NEW_STATUS_WORKFLOW,
  REMOVE_ATTACHMENT,
  BOARD_ATTRIBUTE_TATTLE_DETAILS_NULL,
  ADDING_MONITOR,
  REMOVE_MONITOR,
  MONITOR_ADDING,
  ENABLE_MONITORING,
  NOTE_ADDING,
  NOTE_ADDED,
  BOARD_CREATING,
  BOARD_CREATED,
  CLEARING_ALL_COLUMNS,
  UPDATE_ROW_STATUS,
  IMAGE_UPLOAD_PROGRESS,
  IMAGE_UPLOAD_PROGRESS_COMPLETE,
  IMAGE_UPLOAD_START,
  IMAGE_UPLOAD_ERROR,
  BOARD_ATTRIBUTE_TATTLE_DETAILS_AFTER_UPLOAD,
  ASSIGN_TO_UPDATE,
  ADD_IMAGE_TO_NOTE,
  CLEAR_BOARD_REDUX,
  IMAGE_UPLOAD_DONE,
  CLEAR_ALL_IMAGE,
  IMAGE_UPLOAD_DONE_EDIT,
  IMAGE_UPLOAD_PROGRESS_COMPLETE_ADD_LISTING,
  IMAGE_UPLOAD_PROGRESS_ADD_LISTING,
  IMAGE_UPLOAD_ERROR_ADD_LISTING,
  IMAGE_UPLOAD_DONE_ADD_LISTING,
  REPLY_TO_CUSTOMER,
  IMAGE_UPLOAD_DONE_ADD_LISTING_CHILD_BOARD,
  GET_CHILD_BOARD,
  GET_BOARD_FILTER_ACTION,
  CREATE_CUSTOM_FILTER,
  DELETE_FILTER,
  DELETE_FILTER_ERROR,
  EDIT_FILTER_HANDLER,
  CREATE_CUSTOM_FILTER_ERROR,
  TOGGLE_MENU,
  ADD_REASON_ROW_UPDATE,
  CHILD_BOARD_IMAGE_REMOVE,
  RESET_BOARDS,
  CLEAR_NOTE,
  ADD_TODO_HANDLER,
  RELATE_VICE_VERSA,
};
